import { styled } from "@mui/material/styles";
import DropdownIconAsset from "assets/images/icons/dropdown.svg";
import CheckLightIconAsset from "assets/images/icons/check-light.svg";
import { PlainButton } from "components/button/plain";

export const DatesAndTravelers = styled("h3", {
  label: "dates-and-travelers",
})`
  font-weight: 500;
  font-size: 20px;
`;

export const TripInfo = styled("div", {
  label: "trip-info",
})`
  flex: 0;

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin: ${({ theme }) => theme.spacing(4, 4)};
  }

  & + & {
    margin-top: 0;
    border-top: 1px solid ${({ theme }) => theme.palette.color.gray[80]};
    ${({ theme }) => theme.breakpoints.up("md")} {
      border-top: none;
    }
  }
`;

export const MWebTripDetails = styled("div", {
  label: "mWeb-trip-details",
})`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const TravelersButtonIcon = styled(DropdownIconAsset, {
  label: "travelers-button-icon",
})`
  fill: ${({ theme }) => theme.palette.color.primary.main};
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 0.5)};
  width: ${({ theme }) => theme.spacing(1.25)};
  height: auto;
`;

export const MWebDatesAndTravelers = styled("div", {
  label: "mweb-dates-and-travelers",
})`
  font-weight: 400;
  font-size: 18px;
`;

export const TravelersButton = styled(PlainButton, {
  label: "travelers-button",
})`
  margin-left: ${({ theme }) => theme.spacing(1)};
  vertical-align: baseline;
`;

export const Days = styled("h3", {
  label: "days",
})`
  font-size: 16px;
  line-height: 1.2;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.color.gray[10]};
  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 14px;
    padding-top: ${({ theme }) => theme.spacing(1)};
  }
`;

export const AddonsList = styled("ul", {
  label: "addons-list",
})`
  list-style: none;
  padding-inline-start: 0px;
  display: flex;
  flex-wrap: wrap;
  column-gap: ${({ theme }) => theme.spacing(2)};
  row-gap: ${({ theme }) => theme.spacing(0.5)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const CheckIcon = styled(CheckLightIconAsset, {
  label: "check-icon",
})`
  fill: currentColor;
  width: auto;
  height: ${({ theme }) => theme.spacing(1.5)};
`;

export const AddOnListItem = styled("li", {
  label: "add-on-list-item",
})`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.palette.color.gray[10]};
`;
